<template>
  <div ref="container">
    <a-modal title="仓库" :width="400" :visible="visible" :getContainer="() => $refs.container"
      :maskStyle="{ 'top': '93px', 'left': '154px' }" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()"
      :maskClosable="false" @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
        <a-button key="back" v-if="!uuid" type="primary" @click="submit">确认<a-spin v-if="loading"
            size="small" /></a-button>
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>
      <a-form>
        <a-form-item label="请选择仓库">
          <a-select placeholder="请选择仓库" v-model="form.depotId">
            <a-select-option v-for="item in list" :value="item.id" :key="item.id">{{ item.depotName }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
// import BillDetail from '../../bill/dialog/BillDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { getwarehouse, postWarehousing, postWarehousingCheck } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    // BillDetail,
    JEllipsis,
  },
  data () {
    return {
      disableMixinCreated:true,
      loading: false,
      visible: false,
      list: [],
      form: {
        depotId: '',
      },
      url: {
        list: '/dataAcquisitionAccumulated/list',
      },
    }
  },
  created () { },
  methods: {
    async getlist () {
      const res = await getwarehouse()
      console.log(res, 'res')
      this.list = res.data
    },
    // 提交
    async submit () {
      console.log(this.form.depotId, 'this.form.depotId')
      if (!this.form.depotId) return this.$message.warning('仓库不可为空!')
      this.loading = true
      let obj = {
        depotId: this.form.depotId,
        materialId: this.form.materialId,
        version: this.form.uuid,
        userId: this.$store.getters.userInfo.id,
        batchNumber:this.form.batchNumber
      }
      // 退货校验
      postWarehousingCheck(obj).then(async res => {
        if (res.code == 200) {
          // 退货
          this.$message.success('操作成功')
          this.close()
          this.loading = false
          const SonRes = await postWarehousing(obj)
          if (SonRes.code != 200) {
            this.$message.error(SonRes.data)
          } else {
            this.close()
          }
        } else {
          this.$message.error(res.data)
        }
      })
      // console.log(check)
      // const res = await postWarehousing(obj)
      // console.log(res)
      // if (res.code == 200) {
      //   this.$message.success('入库成功')
      //   this.close()
      //   this.loading = false
      // } else {
      //   this.$message.error(res.data)
      // }
    },
    async show (e) {
      console.log(e, '仓库')
      this.visible = true
      this.getlist()
      this.form = e
      console.log(this.form, 'form')
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.$emit('fatherMethod')
    },
    handleCancel () {
      this.close()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>